import React from 'react'
import { ViewReportList, availableASLDefinition } from 'pages/reports'
import { useGetBalanceReportQuery } from 'features'
import { ErrorBoundary } from 'components'
import { useParams } from 'react-router-dom'
import { ReportExport } from 'pages/reports/ReportExport'

export default function ViewAvailableASLByDNIReport() {
  const { dni = null } = useParams()

  return (
    <div>
      <ErrorBoundary fallback={<div>Error</div>}>
        <div className="flex flex-row justify-end items-center mt-32 gap-4 ">
          <ReportExport
            query={useGetBalanceReportQuery}
            columns={availableASLDefinition}
            title={`Saldo ASL`}
            fileName={`Saldo ASL ${dni && ' - DNI: ' + dni}`}
            queryParams={{
              params: {
                search: dni,
              },
              paginated: false,
            }}
          />
        </div>
        <ViewReportList
          query={useGetBalanceReportQuery}
          rowIdKey="studentid"
          columnDefinition={availableASLDefinition}
          fixedParams={{ search: dni }}
        />
      </ErrorBoundary>
    </div>
  )
}
